import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import axios from "axios";
import { API } from "../lib/api";

const rankCls = (i) =>
  i === 0 ? "bg-fresh text-white" : "bg-forest/10 text-forest/70";

const Row = ({ row, i }) => (
  <li data-testid={`leaderboard-row-${i}`} className="font-manrope text-sm font-semibold text-forest/80">
    <div className="flex items-center gap-3">
      <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full font-syne text-xs font-extrabold ${rankCls(i)}`}>
        {i + 1}
      </span>
      <span className="truncate">{row.name}</span>
      <span className="ml-auto rounded-full bg-fresh/10 px-2.5 py-0.5 text-xs font-bold text-fresh">
        {row.referrals} invite{row.referrals === 1 ? "" : "s"}
      </span>
    </div>
    {i < 3 && row.perks?.length > 0 && (
      <div data-testid={`leaderboard-prize-${i}`} className="ml-9 mt-1 flex flex-wrap gap-1.5">
        {row.perks.map((p) => (
          <span
            key={p}
            className="inline-flex items-center gap-1 rounded-full bg-amber-500/10 px-2 py-0.5 text-[11px] font-bold text-amber-600"
          >
            <Trophy className="h-3 w-3" /> Won {p}
          </span>
        ))}
      </div>
    )}
  </li>
);

export const Leaderboard = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios.get(`${API}/leaderboard`).then((r) => setRows(r.data)).catch(() => {});
  }, []);

  if (!rows.length) return null;

  return (
    <div data-testid="referral-leaderboard" className="mt-8 max-w-lg">
      <p className="font-manrope text-[10px] font-bold uppercase tracking-[0.25em] text-forest/50">
        Top referrers — race to the front of the line
      </p>
      <ol className="mt-3 space-y-1.5">
        {rows.map((r, i) => (
          <Row key={r.name} row={r} i={i} />
        ))}
      </ol>
      <p data-testid="leaderboard-prizes-note" className="mt-3 font-manrope text-xs font-semibold text-forest/50">
        <Trophy className="mr-1 inline h-3 w-3 text-amber-500" />
        5 invites = a month of free delivery · 10 invites = three months free
      </p>
    </div>
  );
};
